import  Petition  from "../../../modules/petition"

/**
 * Use Petition
 *
 * You must use pet.get(url) or pet.post(url, data)
 */
const pet = new Petition()

export class apiService {
	welcome() {
		return 'welcome to ApiService'
	}
	example() {
		return pet.get('http://api.150porciento.com/api/countries')
	}
	// registerform(url: string) {
	// 	return pet.getText(url)
	// }
	validateUser(data: object){
    return pet.post(`/api/user/mail`, data);
  }
	loginUser(data: object){
    return pet.post(`/api/user/login`, data);
  }
	validateUserDni(data: object){
    return pet.post(`/api/user/dni`, data);
  }
	validateUserPhone(data: object){
    return pet.post(`/api/user/phone`, data);
  }
}
